'use client';
import styled from 'styled-components';

export const ProductWrap = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 40px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: flex;
    flex-flow: column;
    gap: 0;
  }
`;

export const ProductMain = styled.main`
  display: flex;
  flex-flow: column;
  max-width: 730px;
  min-width: 530px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down('md')} {
    max-width: none;
    min-width: 100%;
    order: 1;
  }
`;

export const ProductAside = styled.aside`
  max-width: 400px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down('md')} {
    order: 2;
  }
`;

export const StickyBox = styled.div`
  position: sticky;
  top: 4rem;
`;
